import { configureStore, combineReducers } from "@reduxjs/toolkit";
import userReducer from "./reduxSlice/authRedux";
import lessonReducer from "./reduxSlice/lessonRedux";
import videoReducer from "./reduxSlice/videoRedux";
import paymentReducer from "./reduxSlice/paymentRedux";
import pdfReducer from "./reduxSlice/pdfRedux";
import studyPackReducer from "./reduxSlice/studyPackRedux";

const rootReducer = combineReducers({
  user: userReducer,
  lesson: lessonReducer,
  video: videoReducer,
  payment: paymentReducer,
  pdf: pdfReducer,
  studyPack: studyPackReducer,
});

export const store = configureStore({
  reducer: rootReducer,
});


